import { keyframes, styled } from '@mui/system';

import { customPalette } from '../../../styles/theme';

const wave = keyframes`
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(10px);
    }
    100% {
        transform: translateY(0);
    }
`;

const bouncingLoader = keyframes`
    to {
        opacity: 0.1;
        transform: translateY(-16px);
    }
`;

interface LoaderWrapperProps {
  withBlur?: boolean;
}

export const LoaderWrapper = styled('div')<LoaderWrapperProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9999;

  ${(props) =>
    props.withBlur &&
    `
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
  `}
`;

export const StyledLogoWrapper = styled('div')`
  animation: ${wave} 2s infinite;
  margin-bottom: 5px;

  svg {
    width: 70px;
    height: 70px;
  }
`;

export const BouncingLoaderWrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin: 40px auto;
`;

interface BouncingDotProps {
  delay?: string;
}

export const BouncingDot = styled('div')<BouncingDotProps>`
  width: 10px;
  height: 10px;
  margin: 3px 3px;
  border-radius: 50%;
  background-color: ${customPalette.grey['400']};
  opacity: 1;
  animation: ${bouncingLoader} 0.6s infinite alternate;
  animation-delay: ${(props) => props.delay || '0s'};
`;
